class ReplaceOrganizationLogo {
	constructor(
		public readonly organizationId: number,
		public readonly file: File,
	) {
		Object.freeze(this);
	}

	toFormData(): FormData {
		const formData = new FormData();
		formData.append('file', this.file);
		return formData;
	}
}

export default ReplaceOrganizationLogo;
